import { useMainStore } from '~/store'

export const useCurrentPage = async (slug, type) => {
  const store = useMainStore()

  // PREVIEW FEATURE
  // REGEX - LOOKS FOR NETLIFY.APP BUT EXCLUDES -- (IN CASE OF STAGING LINKS)
  const myRegex = /^(?!\w+--).*netlify.app/;

  const apiType = type === 'page' ? 'page_by_slug/' : 
                  type === 'blog-post' ? 'blog_post_by_slug/' : 
                  type === 'blog' ? 'blog_by_slug/' : 
                  type === 'store' ? 'store_by_slug/' : 
                  type === 'gallery' ? 'gallery_by_slug/' : 
                  type === 'banner' ? 'banner_by_slug/' : 
                  type === 'poi' ? 'poi_location_by_slug/' : 
                  'page_by_slug/';
  const draftApiUrl = store.baseURL + apiType + slug + '?draft=true'
  const apiUrl = store.baseURL + apiType + slug + '?status[]=development&status[]=active'
  // CHECKS IF HOSTNAME INCLUDES PREVIEW. OR NETLIFY REGEX ABOVE AND APPENDS DRAFT TRUE TO SHOW DRAFT ONLY
  const url = window.location.hostname.includes('preview.') || myRegex.test(window.location.hostname) ? draftApiUrl : apiUrl

  try {
    const { data } = await store.loadPageData({ url: url })
    if (data) return data
    else navigateTo('/')
  } catch (error) {
    console.log("Error:", error)
    await navigateTo('/')
  }
}